import { render, staticRenderFns } from "./BaseTags.vue?vue&type=template&id=71d88785"
import script from "./BaseTags.vue?vue&type=script&lang=js"
export * from "./BaseTags.vue?vue&type=script&lang=js"
import style0 from "./BaseTags.vue?vue&type=style&index=0&id=71d88785&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports